import * as bootstrap from "sard_core/vendor/assets/bootstrap/javascripts/bootstrap"

const initPopovers = (container = document) => {
  // add content if any html popovers found
  const htmlPopoverTriggerList = container.querySelectorAll('.html-popover')
  htmlPopoverTriggerList.forEach(htmlPopoverTriggerEl => {
    const contentElement = htmlPopoverTriggerEl.nextElementSibling
    if (contentElement?.classList.contains('html-popover-content')) {
      htmlPopoverTriggerEl.setAttribute('data-bs-content', contentElement.innerHTML)
    }
  })

  const popoverTriggerList = [
    ...htmlPopoverTriggerList,
    ...container.querySelectorAll('[data-bs-toggle="popover"]')
  ]

  const popoverList = popoverTriggerList.map(popoverTriggerEl => {
    // Skip if already initialized
    if (bootstrap.Popover.getInstance(popoverTriggerEl)) {
      return null
    }

    let config = { html: true, sanitize: false }
    if (popoverTriggerEl.classList?.contains('html-popover')) {
      config.sanitize = false
      config.container = popoverTriggerEl.parentElement
    }
    return new bootstrap.Popover(popoverTriggerEl, config)
  }).filter(Boolean)

  return popoverList
}

let allPopovers = []

const disposePopovers = () => {
  allPopovers.forEach(popover => {
    if (popover?._element) {
      popover.dispose()
    }
  })
  allPopovers = []
}

Ready(() => {
  allPopovers = initPopovers()

  window.addEventListener("beforeunload", disposePopovers)
  document.addEventListener("turbo:before-visit", disposePopovers)

  // Reinitialize popovers when Turbo Frames load new content
  document.addEventListener("turbo:frame-load", (event) => {
    const newPopovers = initPopovers(event.target)
    allPopovers = [...allPopovers, ...newPopovers]
  })
})
